<template>
  <vs-popup
    :title="titlePopUp"
    :active.sync="activatingPopUp"
    @close="closeWithLoad(false)"
    class="p-5"
  >
    <main class="mt-2 w-full">
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Gambar Layanan</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <div class="flex justify-start w-full gap-4 items-center mb-base">
          <img
            :src="
              formData.file
                ? formData.file.includes('http')
                  ? formData.file
                  : `${url.baseFl}/${formData.file}`
                : emptyImage
            "
            alt="sub-kategori-sos-img"
            class="rounded-lg shadow-md cursor-pointer block mb-4"
          />
          <div>
            <input
              type="file"
              class="hidden"
              ref="updateImgInput"
              @change="updateCurrImg"
              accept="image/*"
            />
            <vs-button class="mr-4 sm:mb-0 mb-2" @click="$refs.updateImgInput.click()"
              >Upload Gambar</vs-button
            >
            <vs-button
              v-if="formData.file !== emptyImage"
              class="mr-4 warning sm:mb-0 mb-2"
              color="danger"
              @click="resetImg"
              >Clear</vs-button
            >
            <!-- <p class="text-sm mt-2">Allowed JPG, GIF or PNG. Max size of 800kB</p> -->
          </div>
        </div>
        <span class="text-danger text-sm">{{ errors.first("transaction type") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Nama Metode</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="payment method name"
          class="w-full sidebar-input"
          v-model="formData.name"
          placeholder="Isi Dengan Nama Metode Pembayaran"
        />
        <span class="text-danger text-sm">{{ errors.first("payment method name") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Kode</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="code"
          class="w-full sidebar-input"
          v-model="formData.code"
          placeholder="Isi Dengan Kode"
        />
        <span class="text-danger text-sm">{{ errors.first("code") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Kategori</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="category"
          class="w-full sidebar-input"
          v-model="formData.category"
          placeholder="Isi Dengan Kategori Metode Pembayaran"
        />
        <span class="text-danger text-sm">{{ errors.first("category") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Payment Gateway</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="gatewayStatus"
          class="w-full"
          :reduce="(e) => e.id"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="gateway"
          label="text"
          v-model="formData.gateway"
          placeholder="Pilih Payment Gateway"
        />
        <span class="text-danger text-sm">{{ errors.first("gateway") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Min. Transaksi</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          @keypress="onlyNumber"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="minimal transaction"
          class="w-full sidebar-input"
          v-model="formData.min_transaction"
          placeholder="Isi Dengan Minimal Transaksi"
        />
        <span class="text-danger text-sm">{{ errors.first("minimal transaction") }}</span>
      </div>
      <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Max. Transaksi</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <vs-input
          @keypress="onlyNumber"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="maximal transaction"
          class="w-full sidebar-input"
          v-model="formData.max_transaction"
          placeholder="Isi Dengan Maksimal Transaksi"
        />
        <span class="text-danger text-sm">{{ errors.first("maximal transaction") }}</span>
      </div>
      <!-- <div class="mb-6">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Jenis Transaksi</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <v-select
          :options="gatewayStatus"
          class="w-full"
          :reduce="(e) => e.id"
          v-validate="'required'"
          data-vv-validate-on="blur"
          name="gateway"
          label="text"
          v-model="formData.gateway"
          placeholder="Pilih Payment Gateway"
        />
        <span class="text-danger text-sm">{{ errors.first("gateway") }}</span>
      </div> -->
      <div class="mb-6 flex justify-between">
        <section class="mb-4 flex justify-start gap-1">
          <h6><strong>Aktifasi Layanan</strong></h6>
          <span class="text-danger">*</span>
        </section>
        <section class="flex justify-end gap-3 items-center">
          <p class="text-sm">{{ enabled ? "Aktif" : "Tidak Aktif" }}</p>
          <vs-switch color="success" v-model="enabled" />
        </section>
      </div>
    </main>
    <footer class="mt-4">
      <div class="flex justify-end items-center mr-4 mb-4">
        <vs-button color="danger" class="mr-2 rounded-2xl" @click="closeWithLoad(false)"
          >Cancel</vs-button
        >
        <vs-button
          color="success"
          class="ml-2 rounded-2xl"
          :disabled="!validateForm"
          @click="addWithOption"
          >{{ labelButton }}</vs-button
        >
      </div>
    </footer>
  </vs-popup>
</template>
<script>
import emptyImage from "@/assets/images/elements/empty.png";
import url from "@/url.js";

export default {
  props: {
    activate: { type: Boolean, default: false },
    passData: { type: Object, default: null },
  },
  data() {
    return {
      url,
      emptyImage,
      gatewayStatus: [
        {
          id: 1,
          text: "Midtrans",
        },
        {
          id: 2,
          text: "Xendit",
        },
      ],
      binaryFile: "",
      enabled: false,
      formData: {
        file: emptyImage,
        gateway: 1,
        name: "",
        code: "",
        min_transaction: "",
        max_transaction: "",
        category: "",
        gateway: null,
        is_enabled: 0,
      },
    };
  },
  computed: {
    titlePopUp() {
      return this.passData != null
        ? "Edit Metode Pembayaran"
        : "Tambah Metode Pembayaran";
    },
    labelButton() {
      return this.passData != null ? "Edit" : "Submit";
    },
    validateForm() {
      return (
        !this.errors.any() &&
        this.formData.name !== "" &&
        this.formData.file !== "" &&
        this.formData.code !== "" &&
        this.formData.category !== "" &&
        this.formData.min_transaction !== "" &&
        this.formData.max_transaction !== "" &&
        this.formData.gateway !== null
      );
    },
    activatingPopUp: {
      get() {
        return this.activate;
      },
      set(val) {
        this.$emit("callback", val);
      },
    },
  },
  watch: {
    activate() {
      if (this.passData !== null) {
        this.formData.name = this.passData.name;
        this.formData.file = this.getPathFoto(this.passData);
        this.formData.code = this.passData.code;
        this.formData.min_transaction = this.passData.min_transaction;
        this.formData.max_transaction = this.passData.max_transaction;
        this.formData.category = this.passData.category;
        this.formData.is_enabled = this.passData.is_enabled;
        this.formData.gateway = this.passData.gateway;
        this.enabled = this.passData.is_enabled === 1;
      } else {
        this.resetForm();
      }
    },
    enabled() {
      if (this.enabled) {
        this.formData.is_enabled = 1;
      } else {
        this.formData.is_enabled = 0;
      }
    },
  },
  methods: {
    resetImg() {
      this.formData.file = this.emptyImage;
      this.binaryFile = "";
    },
    resetForm() {
      this.formData.name = "";
      this.formData.file = this.emptyImage;
      this.formData.code = "";
      this.formData.min_transaction = "";
      this.formData.max_transaction = "";
      this.formData.category = "";
      this.formData.is_enabled = 0;
      this.enabled = false;
      this.formData.gateway = null;
      this.binaryFile = "";
    },
    profile() {
      return JSON.parse(localStorage.getItem("profileAccess")).data;
    },
    closeWithLoad(load) {
      this.activatingPopUp = false;
      this.$emit("withClose", load);
    },
    addWithOption() {
      this.$vs.loading({
        color: "primary",
      });
      if (this.binaryFile === "") {
        this.addData();
      } else {
        this.addWithFile();
      }
    },
    addWithFile() {
      this.$store
        .dispatch("file/addFile", this.binaryFile)
        .then((v) => {
          this.formData.file = v.link;
          this.addData();
        })
        .catch((e) => {
          this.$vs.loading.close();
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        });
    },
    addData() {
      let id = {};
      if (this.passData !== null) {
        id = {
          id: this.passData.id,
        };
      }
      if (this.formData.file === this.emptyImage) {
        this.formData.file = null;
      }
      this.$store
        .dispatch("transaksi/cudMetodePembayaran", [{ ...this.formData, ...id }])
        .then((v) => {
          this.$vs.notify({
            position: "top-right",
            title:
              this.passData !== null
                ? "Edit Metode Pembayaran Sukses!"
                : "Tambah Metode Pembayaran Sukses!",
            text:
              this.passData !== null
                ? `Metode Pembayaran ${v.name} Berhasil diedit`
                : `Metode Pembayaran ${v.name} Berhasil ditambah`,
            iconPack: "feather",
            icon: "icon-smile",
            color: "primary",
          });
          this.closeWithLoad(true);
        })
        .catch((e) => {
          if (e.response) {
            console.error(e.response.status);
            this.$vs.notify({
              position: "top-right",
              title: "Oops!",
              text: e.response.data.message,
              iconPack: "feather",
              icon: "icon-alert-circle",
              color: "danger",
            });
          }
        })
        .finally(() => {
          this.$vs.loading.close();
          this.resetForm();
        });
    },
    updateCurrImg(input) {
      if (input.target.files && input.target.files[0]) {
        const reader = new FileReader();
        reader.onload = (e) => {
          this.formData.file = e.target.result;
          this.binaryFile = input.target.files[0];
        };
        reader.readAsDataURL(input.target.files[0]);
      }
    },
  },
};
</script>
<style lang="scss" scoped>
img {
  max-width: 92px;
  max-height: 92px;
  overflow: auto;
  object-fit: cover;
}
</style>
